import { QnAState } from "./QnAState"
import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './QnA.css'
import { QnA } from '../../../configs/interactions-entities'
import { Observable, Observer, Subscription } from 'rxjs'

class QnAList extends React.Component<any, QnAState> {
    private bottom: React.RefObject<HTMLDivElement>
    private questionIdList: string[] = []
    private questionList: QnA[] = []
    private gratitudeDisposable: Subscription
    private qnaDisposable: Subscription

    constructor(props: any) {
        super(props)
        const newState = new QnAState()
        newState.qnaEnabled = this.props.qnaEnabled
        this.bottom = React.createRef<HTMLDivElement>()
        this.state = newState
    }

    public componentWillUpdate(nextProps: any, nextState: QnAState) {
        if (nextProps.streamId !== undefined && nextProps.streamId.length > 0) {
            const qnaObservable = Observable.create((sub: Observer<QnA>) => {
                firebase.firestore().collection('classes').doc(nextProps.streamId).collection('qna').onSnapshot(o => {
                    o.docChanges().forEach(elm => {
                        if (this.questionIdList[elm.doc.id] === undefined) {
                            const newQnA = new QnA()
                            newQnA.id = elm.doc.id
                            newQnA.question = elm.doc.data()!.question
                            newQnA.user = elm.doc.data()!.user
                            newQnA.uuid = elm.doc.data()!.uuid
                            newQnA.date = new Date()
                            this.questionIdList[newQnA.id] = newQnA.question
                            this.questionList.push(newQnA)
                            this.state.questions!.push(`${newQnA.user}: ${newQnA.question}`)
                            this.setState({ questions: this.state.questions })
                        }
                    })
                })
                sub.next(new QnA())
            })

            const gratitudeObservable = Observable.create((sub: Observer<QnA>) => {
                firebase.firestore().collection('classes').doc(nextProps.streamId).collection('gratitude').orderBy("date", "asc").onSnapshot(o => {
                    o.docChanges().forEach(elm => {
                        if (this.questionIdList[elm.doc.id] === undefined) {
                            const newQnA = new QnA()
                            newQnA.id = elm.doc.id
                            newQnA.question = elm.doc.data()!.gratitude
                            newQnA.user = elm.doc.data()!.username
                            newQnA.uuid = elm.doc.data()!.uuid
                            newQnA.date = elm.doc.data()!.date !== undefined ? elm.doc.data()!.date.toDate() : new Date()
                            sub.next(newQnA)
                        }
                    })
                })
            })

            this.qnaDisposable = qnaObservable.subscribe()

            this.gratitudeDisposable = gratitudeObservable.subscribe((val: QnA) => {
                this.questionIdList[val.id] = val.question
                this.questionList.push(val)
                this.state.questions!.push(`${val.user}: ${val.question}`)
                this.setState({ questions: this.state.questions })
            })

        }
    }

    public componentDidUpdate() {
        this.bottom.current!.scrollTop = this.bottom.current!.scrollHeight
    }

    public componentWillUnmount() {
        if (this.gratitudeDisposable !== undefined) {
            this.gratitudeDisposable.unsubscribe()
        }
        if (this.qnaDisposable !== undefined) {
            this.qnaDisposable.unsubscribe()
        }
    }

    public render() {
        return (<div className="QnA" ref={this.bottom}>
            {this.state.questions.map((q, i) =>
                <p key={i} data-id={i}>{q}</p>
            )}
        </div>)
    }
}

export default QnAList


// WEBPACK FOOTER //
// ./src/components/stream/qna/QnAList.tsx